﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.6.0 (NJsonSchema v10.0.28.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import moment from 'moment';

export class ServiceProxy {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * Sets the status of a message (e.g.: delivered, read, etc.)
     * @param input (optional) MarkMessageStatusInput
     * @return Success
     */
    markMessageStatuses(input: MarkMessageStatusInput | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/MarkMessageStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkMessageStatuses(_response);
        });
    }

    protected processMarkMessageStatuses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Adds a sender action (e.g.: typing on, typing off, etc.)
     * @param input (optional) MarkSenderActionInput
     * @return Success
     */
    markSenderActions(input: MarkSenderActionInput | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/MarkSenderActions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarkSenderActions(_response);
        });
    }

    protected processMarkSenderActions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Returns the status of a conversation
     * @param conversationId (optional)
     * @param watermark (optional)
     * @param forActivities (optional)
     * @return Success
     */
    getStatus(conversationId: string | null | undefined, watermark: number | null | undefined, forActivities: string[] | null | undefined): Promise<ConversationStatus> {
        let url_ = this.baseUrl + "/GetStatus?";
        if (conversationId !== undefined)
            url_ += "ConversationId=" + encodeURIComponent("" + conversationId) + "&";
        if (watermark !== undefined)
            url_ += "Watermark=" + encodeURIComponent("" + watermark) + "&";
        if (forActivities !== undefined)
            forActivities && forActivities.forEach(item => { url_ += "ForActivities=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<ConversationStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConversationStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConversationStatus>(<any>null);
    }

    /**
     * Connects two conversations
     * @param input (optional)
     * @return Success
     */
    connectConversations(input: ConnectConversationsInput | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/ConnectConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processConnectConversations(_response);
        });
    }

    protected processConnectConversations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Disconnects two conversations
     * @param input (optional)
     * @return Success
     */
    disconnectConversations(input: DisconnectConversationsInput | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/DisconnectConversations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDisconnectConversations(_response);
        });
    }

    protected processDisconnectConversations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }
}


export class MarkMessageStatusInput implements IMarkMessageStatusInput {
    conversationId: string | undefined;
    isFromBot: boolean;
    messageStatuses: MessageStatusInputDto[] | undefined;

    constructor(data?: IMarkMessageStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"];
            this.isFromBot = _data["isFromBot"];
            if (Array.isArray(_data["messageStatuses"])) {
                this.messageStatuses = [] as any;
                for (let item of _data["messageStatuses"])
                    this.messageStatuses.push(MessageStatusInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkMessageStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkMessageStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId;
        data["isFromBot"] = this.isFromBot;
        if (Array.isArray(this.messageStatuses)) {
            data["messageStatuses"] = [];
            for (let item of this.messageStatuses)
                data["messageStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkMessageStatusInput {
    conversationId: string | undefined;
    isFromBot: boolean;
    messageStatuses: MessageStatusInputDto[] | undefined;
}


export class MessageStatusInputDto implements IMessageStatusInputDto {
    activityId: string | undefined;
    routedActivityId: string | undefined;
    sourceMessageId: string | undefined;
    dateTimeUtc: moment.Moment | undefined;
    status: MessageStatusInputDtoStatus | undefined;

    constructor(data?: IMessageStatusInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.routedActivityId = _data["routedActivityId"];
            this.sourceMessageId = _data["sourceMessageId"];
            this.dateTimeUtc = _data["dateTimeUtc"] ? moment(_data["dateTimeUtc"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MessageStatusInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStatusInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["routedActivityId"] = this.routedActivityId;
        data["sourceMessageId"] = this.sourceMessageId;
        data["dateTimeUtc"] = this.dateTimeUtc ? this.dateTimeUtc.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IMessageStatusInputDto {
    activityId: string | undefined;
    routedActivityId: string | undefined;
    sourceMessageId: string | undefined;
    dateTimeUtc: moment.Moment | undefined;
    status: MessageStatusInputDtoStatus | undefined;
}

export class ErrorDetails implements IErrorDetails {
    statusCode: number | undefined;
    message: string | undefined;
    stackTrace: string | undefined;

    constructor(data?: IErrorDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statusCode = _data["statusCode"];
            this.message = _data["message"];
            this.stackTrace = _data["stackTrace"];
        }
    }

    static fromJS(data: any): ErrorDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["message"] = this.message;
        data["stackTrace"] = this.stackTrace;
        return data;
    }
}

export interface IErrorDetails {
    statusCode: number | undefined;
    message: string | undefined;
    stackTrace: string | undefined;
}

export class MarkSenderActionInput implements IMarkSenderActionInput {
    conversationId: string | undefined;
    isFromBot: boolean;
    senderAction: SenderAction;

    constructor(data?: IMarkSenderActionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId = _data["conversationId"];
            this.isFromBot = _data["isFromBot"];
            this.senderAction = _data["senderAction"] ? SenderAction.fromJS(_data["senderAction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkSenderActionInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkSenderActionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId"] = this.conversationId;
        data["isFromBot"] = this.isFromBot;
        data["senderAction"] = this.senderAction ? this.senderAction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMarkSenderActionInput {
    conversationId: string | undefined;
    isFromBot: boolean;
    senderAction: SenderAction;
}

export class SenderAction implements ISenderAction {
    dateTimeUtc: moment.Moment | undefined;
    action: SenderActionAction | undefined;

    constructor(data?: ISenderAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTimeUtc = _data["dateTimeUtc"] ? moment(_data["dateTimeUtc"].toString()) : <any>undefined;
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): SenderAction {
        data = typeof data === 'object' ? data : {};
        let result = new SenderAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTimeUtc"] = this.dateTimeUtc ? this.dateTimeUtc.toISOString() : <any>undefined;
        data["action"] = this.action;
        return data;
    }
}

export interface ISenderAction {
    dateTimeUtc: moment.Moment | undefined;
    action: SenderActionAction | undefined;
}

export class ConversationStatus implements IConversationStatus {
    messageStatuses: MessageStatusOutputDto[] | undefined;
    botAction: SenderAction | undefined;

    constructor(data?: IConversationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messageStatuses"])) {
                this.messageStatuses = [] as any;
                for (let item of _data["messageStatuses"])
                    this.messageStatuses.push(MessageStatusOutputDto.fromJS(item));
            }
            this.botAction = _data["botAction"] ? SenderAction.fromJS(_data["botAction"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ConversationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ConversationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messageStatuses)) {
            data["messageStatuses"] = [];
            for (let item of this.messageStatuses)
                data["messageStatuses"].push(item.toJSON());
        }
        data["botAction"] = this.botAction ? this.botAction.toJSON() : <any>undefined;
        return data;
    }
}

export interface IConversationStatus {
    messageStatuses: MessageStatusOutputDto[] | undefined;
    botAction: SenderAction | undefined;
}

export class MessageStatusOutputDto implements IMessageStatusOutputDto {
    activityId: string | undefined;
    status: MessageStatusOutputDtoStatus | undefined;

    constructor(data?: IMessageStatusOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): MessageStatusOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageStatusOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["status"] = this.status;
        return data;
    }
}

export interface IMessageStatusOutputDto {
    activityId: string | undefined;
    status: MessageStatusOutputDtoStatus | undefined;
}

export class ConnectConversationsInput implements IConnectConversationsInput {
    conversationId1: string | undefined;
    conversationId2: string | undefined;

    constructor(data?: IConnectConversationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId1 = _data["conversationId1"];
            this.conversationId2 = _data["conversationId2"];
        }
    }

    static fromJS(data: any): ConnectConversationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectConversationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId1"] = this.conversationId1;
        data["conversationId2"] = this.conversationId2;
        return data;
    }
}

export interface IConnectConversationsInput {
    conversationId1: string | undefined;
    conversationId2: string | undefined;
}

export class DisconnectConversationsInput implements IDisconnectConversationsInput {
    conversationId1: string | undefined;
    conversationId2: string | undefined;

    constructor(data?: IDisconnectConversationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.conversationId1 = _data["conversationId1"];
            this.conversationId2 = _data["conversationId2"];
        }
    }

    static fromJS(data: any): DisconnectConversationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisconnectConversationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["conversationId1"] = this.conversationId1;
        data["conversationId2"] = this.conversationId2;
        return data;
    }
}

export interface IDisconnectConversationsInput {
    conversationId1: string | undefined;
    conversationId2: string | undefined;
}

export enum MessageStatusInputDtoStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export enum SenderActionAction {
    _0 = 0,
    _1 = 1,
}

export enum MessageStatusOutputDtoStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}